/* Shopify owns consent storage and the first-visit banner. This link reopens
   its preferences without discarding or automatically changing a choice. */
document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-ryvt-privacy-preferences]');
  if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  if (typeof window.privacyBanner?.showPreferences !== 'function') return;
  event.preventDefault();
  Promise.resolve().then(() => window.privacyBanner.showPreferences()).catch(() => {
    window.location.assign(link.href);
  });
});
